import $ from 'jquery';
import { $win, $doc, $body } from "../utils/globals";

function navClose() {
  $doc.on("click", function(e) {
    if (!e.target.closest(".nav")) {
      $(".nav")
        .find("li")
        .removeClass("hovered");
    }
  });
}

export default navClose;
